<template>
  <PForm
    nested
    :schema="r$"
    :validate-on="['blur', 'input']"
    class="model-edit-form-location flex flex-col"
  >
    <div class="primary-lighten-1 flex w-full flex-col gap-y-2 rounded-md p-2">
      <PFormField sr-only label="Locatienaam" name="name">
        <PInput v-model="location.name" placeholder="Locatienaam" ref="inputName" />
      </PFormField>
    </div>
  </PForm>
</template>

<script setup lang="ts">
import PForm from "@/components/form/PForm.vue"
import { computed, watchEffect, inject, onMounted, ref } from "vue"
import { useRegle } from "@regle/core"
import PFormField from "@/components/form/PFormField.vue"
import { requiredValidator } from "@/helper/validation/validators"
import { useFormConfigurator } from "@/composables/form/form-configurator"
import { Location } from "@/models/location.model"
import type { LocationController } from "@/controllers/model-controllers/location-controller"
import { formFocusHack } from "@/helper/form-helper"
import PInput from "@/components/form/PInput.vue"

const controller: LocationController = inject("locationController")!
const { model: location, isFormInvalid } = useFormConfigurator<Location>({ controller })

const inputName = ref()
onMounted(() => {
  formFocusHack(inputName, location, "name")
})
const rules = {
  name: { requiredValidator }
}

const { r$ } = useRegle(
  computed(() => ({ name: location.value.name })),
  rules,
  { autoDirty: false }
)

watchEffect(() => {
  isFormInvalid.value = r$.$invalid
})
</script>

<style scoped></style>
